module.exports = __webpack_public_path__ + "img/lawseback.ef3cb901.png";